(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.ApplicationDetailsController = (function(superClass) {
    extend(ApplicationDetailsController, superClass);

    function ApplicationDetailsController(scope, transitions, modal, http, service, state, q, ngModal) {
      var func, i, j, ref;
      this.scope = scope;
      this.transitions = transitions;
      this.modal = modal;
      this.http = http;
      this.service = service;
      this.state = state;
      this.q = q;
      this.ngModal = ngModal;
      this.launchAddSourceDialog = bind(this.launchAddSourceDialog, this);
      this.clearInvalidSource = bind(this.clearInvalidSource, this);
      this.sourceValidForApplicator = bind(this.sourceValidForApplicator, this);
      this.filterSources = bind(this.filterSources, this);
      this.loadSources = bind(this.loadSources, this);
      this.sourceChanged = bind(this.sourceChanged, this);
      ApplicationDetailsController.__super__.constructor.apply(this, arguments);
      this.launchDialogTriggers = {};
      this.fieldSurveyForNewMachinery = null;
      this.newMachinery = (function(_this) {
        return function(machinery) {
          var letter, machineId, typeId;
          typeId = machinery.type.id;
          letter = (function() {
            switch (typeId) {
              case 3:
                return 's';
              case 4:
                return 'f';
            }
          })();
          if (letter == null) {
            return;
          }
          machineId = letter + machinery.id;
          return _this.loadApplicators().then(function() {
            var applicator, j, len, ref;
            ref = _this.applicators;
            for (j = 0, len = ref.length; j < len; j++) {
              applicator = ref[j];
              if (applicator.id === machineId && _this.filterApplicators(_this.fieldSurveyForNewMachinery)(applicator)) {
                _this.fieldSurveyForNewMachinery.data.applicator = machineId;
                return;
              }
            }
          });
        };
      })(this);
      this.applicators = [];
      this.loadApplicators();
      this.loadSources();
      this.loadUnitTypes();
      for (i = j = 0, ref = this.service.survey.fields_nitrogen_surveys.length - 1; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
        func = (function(_this) {
          return function(index) {
            return _this.scope.$watch("service.survey.fields_nitrogen_surveys[" + i + "].data.rate", function(newRate, oldRate) {
              if (newRate === 'Variable Rate' && !_this.selectedApplicatorIsVariableRate(_this.service.survey.fields_nitrogen_surveys[index])) {
                return _this.service.survey.fields_nitrogen_surveys[index].data.rate = oldRate;
              }
            });
          };
        })(this);
        func(i);
      }
    }

    ApplicationDetailsController.prototype.sourceChanged = function(fieldSurvey) {
      if (!fieldSurvey.data.source) {
        return;
      }
      return fieldSurvey.data.source_is_custom = (_.find(this.sources, {
        id: fieldSurvey.data.source
      })).is_custom;
    };

    ApplicationDetailsController.prototype.loadUnitTypes = function() {
      return this.http.get('backend/grower/layers/fertilizer/custom-source-unit-options').then((function(_this) {
        return function(response) {
          return _this.unitOptions = response.data;
        };
      })(this));
    };

    ApplicationDetailsController.prototype.loadApplicators = function() {
      var fertilizerPromise, sprayerPromise;
      fertilizerPromise = this.http.get('api/machinery-fertilizers').then((function(_this) {
        return function(response) {
          var applicators, fertilizer, j, len, ref;
          applicators = [];
          ref = response.data;
          for (j = 0, len = ref.length; j < len; j++) {
            fertilizer = ref[j];
            if (fertilizer.fertilizer_source_type != null) {
              applicators.push({
                id: 'f' + fertilizer.id,
                name: fertilizer.name + " (" + fertilizer.fertilizer_source_type + "/" + fertilizer.app_method + ")",
                application_method: fertilizer.app_method,
                fertilizer_source_type: fertilizer.fertilizer_source_type,
                variable_rate: fertilizer.variable_rate
              });
            } else {
              applicators.push({
                id: 'f' + fertilizer.id,
                name: fertilizer.name + " (" + fertilizer.app_method + ")",
                application_method: fertilizer.app_method,
                fertilizer_source_type: fertilizer.fertilizer_source_type,
                variable_rate: fertilizer.variable_rate
              });
            }
          }
          return applicators;
        };
      })(this));
      sprayerPromise = this.http.get('api/machinery-sprayers').then((function(_this) {
        return function(response) {
          var applicators, j, len, ref, sprayer;
          applicators = [];
          ref = response.data;
          for (j = 0, len = ref.length; j < len; j++) {
            sprayer = ref[j];
            if (sprayer.used_for_fertilizer) {
              applicators.push({
                id: 's' + sprayer.id,
                name: sprayer.name + " (Liquid/" + sprayer.app_method + ")",
                application_method: sprayer.app_method,
                fertilizer_source_type: sprayer.fertilizer_source_type,
                variable_rate: sprayer.variable_rate
              });
            }
          }
          return applicators;
        };
      })(this));
      return this.q.all([fertilizerPromise, sprayerPromise]).then((function(_this) {
        return function(applicators) {
          var fertilizers, sprayers;
          fertilizers = applicators[0], sprayers = applicators[1];
          _this.applicators = [].concat(fertilizers, sprayers);
          return _this.applicators;
        };
      })(this));
    };

    ApplicationDetailsController.prototype.loadSources = function() {
      this.sources = [];
      return this.http.get('backend/grower/layers/fertilizer/sources').then((function(_this) {
        return function(response) {
          return _this.sources = _.filter(response.data, function(source) {
            return parseFloat(source.nitrogen) > 0;
          });
        };
      })(this));
    };

    ApplicationDetailsController.prototype.filterSources = function(applicatorId) {
      var applicator;
      applicator = _.find(this.applicators, {
        id: applicatorId
      });
      return (function(_this) {
        return function(source) {
          if (applicator == null) {
            return true;
          }
          return _this.sourceValidForApplicator(source, applicator);
        };
      })(this);
    };

    ApplicationDetailsController.prototype.sourceValidForApplicator = function(source, applicator) {
      var ref;
      if (source.is_manure) {
        return false;
      }
      if (source.application_type === 'Anhydrous' && applicator.application_method !== 'Anhydrous Ammonia') {
        return false;
      }
      if (source.application_type === 'Liquid' && ((ref = applicator.fertilizer_source_type) != null ? ref.toLowerCase() : void 0) === 'dry') {
        return false;
      }
      return true;
    };

    ApplicationDetailsController.prototype.clearInvalidSource = function(fieldSurvey) {
      var applicator, source;
      source = _.find(this.sources, {
        id: fieldSurvey.data.source
      });
      applicator = _.find(this.applicators, {
        id: fieldSurvey.data.applicator
      });
      if (source && applicator && !this.sourceValidForApplicator(source, applicator)) {
        return fieldSurvey.data.source = null;
      }
    };

    ApplicationDetailsController.prototype.launchAddSourceDialog = function(fieldSurvey, inputName) {
      var applicator, applicatorIsLiquid;
      applicator = this.applicators.find((function(_this) {
        return function(item) {
          return item.id === fieldSurvey.data['applicator'];
        };
      })(this));
      if (fieldSurvey.data['applicator'].includes('s') || fieldSurvey.data['applicator'].includes('p')) {
        applicatorIsLiquid = true;
      } else if (fieldSurvey.data['applicator'].includes('f')) {
        applicatorIsLiquid = applicator.fertilizer_source_type === 'liquid' && applicator.application_method !== 'Anhydrous Amonia';
      }
      return this.ngModal.openAddSourceDialog(applicatorIsLiquid, this.unitOptions).modalRef.result.then((function(_this) {
        return function(result) {
          _this.loadSources();
          return _this.fieldSurvey.data[inputName] = result.id;
        };
      })(this))["catch"](_.noop);
    };

    ApplicationDetailsController.prototype.launchAddApplicatorDialog = function(fieldSurvey) {
      if (!this.launchDialogTriggers[fieldSurvey.id]) {
        this.launchDialogTriggers[fieldSurvey.id] = 0;
      }
      this.launchDialogTriggers[fieldSurvey.id]++;
      return this.fieldSurveyForNewMachinery = fieldSurvey;
    };

    ApplicationDetailsController.prototype.filterApplicators = function(fieldSurvey) {
      return function(applicator) {
        if (fieldSurvey.data['rate'] === 'Variable Rate') {
          return applicator.variable_rate;
        }
        return true;
      };
    };

    ApplicationDetailsController.prototype.selectedApplicatorIsVariableRate = function(fieldSurvey) {
      var applicator, id, j, len, ref;
      id = fieldSurvey.data.applicator;
      if (!id) {
        return true;
      }
      ref = this.applicators;
      for (j = 0, len = ref.length; j < len; j++) {
        applicator = ref[j];
        if (applicator.id === id) {
          return applicator.variable_rate;
        }
      }
    };

    return ApplicationDetailsController;

  })(Controller);

}).call(this);
